<template>
	<el-dialog
		:title="'Add/Edit Non-coverage Activity'"
		:visible.sync="showNonCoverageActivity"
		custom-class="custom-class-add-or-edit-section"
	>
		<el-row :gutter="20" class="mb-6">
			<el-col :span="24">
				<div style="display: flex; justify-content: space-between" class="mb-2">
					<h2 class="popup-title">Add/Edit Non-coverage Activity</h2>
					<!-- <el-button
						icon="el-icon-close"
						size="mini"
						circle
						@click="showNonCoverageActivity = false"
					></el-button> -->
					<span class="cursor-pointer" style="font-size: 28px; color: #333;" @click="showNonCoverageActivity = false">
					<i class="el-icon-circle-close"></i>
				</span>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20" class="mb-3">
			<el-col :span="6">
				<p class="font-bold py-1">Section</p>
				<el-select
					v-model="section_function_data.id"
					filterable
					style="width: 100%;"
					size="small"
					placeholder="Select Section"
					@change="(event) => section_function_data = {...sections.find(el => el.id == event), mapped_functions: [], activities: []}"
				>
					<el-option
						v-for="(section, sectionIndex) in sections"
						:key="'section-func-map-' + sectionIndex"
						:value="section.id"
						:label="section.name"
					></el-option>
				</el-select>
			</el-col>
			<el-col :span="6">
				<p class="font-bold py-1">Station</p>
				<el-select
					v-model="section_function_data.mapped_functions"
					filterable
					style="width: 100%"
					multiple
					:multiple-limit="1"
					collapse-tags
					placeholder="Select Station"
					size="small"
					:disabled="!section_function_data.id"
					@change="unselectTagHandlerNonCoverageStation"
					>
					<!-- @remove-tag="selectNonCoverageStationsForDeletion" -->
					<el-option value="add_new">
						<span style="color: #f9a168">Add-Edit Station</span>
					</el-option>
					<el-option
						v-for="(func, index5) in storeFunctions"
						:key="'function-sec-map-'+index5"
						:value="func.id"
						:label="func.function"
						></el-option>
						<!-- :disabled="checkIfMappedNonCoverageActivity(section_function_data.id, func.id)" -->
				</el-select>
			</el-col>
			<el-col :span="6">
				<p class="font-bold py-1">Activity</p>
				<el-select
					v-model="section_function_data.activities"
					filterable
					style="width: 100%"
					multiple
					collapse-tags
					placeholder="Select Station"
					size="small"
					:disabled="!section_function_data.mapped_functions"
					@change="handleChangeNewActivityAddPopup"
				>
					<el-option value="add_new">
						<span style="color: #f9a168">Add-Edit Activity</span>
					</el-option>
					<el-option
						v-for="(func, index5) in activity_type_list"
						:key="'activity-sec-map-'+index5"
						:value="func.id"
						:label="func.name"
					></el-option>
				</el-select>
				<!-- :disabled="activityAlreadyInUse(section_function_data.id, section_function_data.mapped_functions ? section_function_data.mapped_functions[0] ? section_function_data.mapped_functions[0] : null :null, func.id)" -->
			</el-col>
			<el-col :span="6">
				<p class="font-bold py-1">Time Frame</p>
				<el-select
					v-model="section_function_data.time_frame"
					filterable
					style="width: 100%"
					multiple
					collapse-tags
					placeholder="Select Time Frame"
					size="small"
					:disabled="!section_function_data.mapped_functions"
					@change="handleChangeNewActivityAddPopup"
				>
					<el-option
						v-for="(tf, index6) in time_frame_list"
						:key="'time-frame-map-'+index6"
						:value="tf.id"
						:label="tf.name"
					></el-option>
				</el-select>
				<!-- :disabled="activityAlreadyInUse(section_function_data.id, section_function_data.mapped_functions ? section_function_data.mapped_functions[0] ? section_function_data.mapped_functions[0] : null :null, func.id)" -->
			</el-col>
		</el-row>
		<div class="mt-2 text-right">
			<!-- <el-button type="warning" size="small" class="primary-settings-button__save" round @click.prevent="addOrEditSectionStationMapping"
				>Save</el-button
			> -->
			<el-button
				type="warning"
				size="small"
				class="primary-settings-button__save"
				:disabled="!section_function_data.id || !section_function_data || !section_function_data.mapped_functions || !section_function_data.mapped_functions.length || !section_function_data.activities || !section_function_data.activities.length"
				:style="(!section_function_data.id || !section_function_data || !section_function_data.mapped_functions || !section_function_data.mapped_functions.length || !section_function_data.activities || !section_function_data.activities.length) ? 'opacity: 0.6; cursor: not-allowed;' : ''"
				round
				@click.prevent="mapStationWithFunction"
				>Save</el-button
			>
		</div>
	</el-dialog>
</template>

<script>
import settingsMixin from "../../../../../../mixins/settingsMixin";
export default {
	name: "SectionAndStationMapping",
	mixins: [settingsMixin],
};
</script>

<style lang="scss">
.company-settings .custom-class-add-or-edit-section {
	.el-dialog__header {
		display: none;
	}
}
</style>
